import service from "../service";
import { getApiBaseUrl } from "../config";

export default {
    async signup(args) {
        const response = await service.post(
            `${getApiBaseUrl()}auth/register`,
            args
        );
        return response;
    },

    async login(args) {
        const response = await service.post(
            `${getApiBaseUrl()}auth/login`,
            args
        );
        return response;
    },

    async refreshAccessToken() {
        const response = await service.post(
            `${getApiBaseUrl()}auth/token/access`
        );
        return response;
    },

    async findID(args) {
        const response = await service.post(`${getApiBaseUrl()}auth/find/id`, args);
        return response;
    },


    async findPassword(args) {
        const response = await service.post(`${getApiBaseUrl()}auth/find/password`, args);
        return response;
    },


    async resetPassword(args) {
        const response = await service.post(`${getApiBaseUrl()}auth/reset-password`, args);
        return response;
    },

    async getUserProfile() {
        const response = await service.get(`${getApiBaseUrl()}auth/profile`);
        return response;
    },
};
